module.exports = "<p>\n  affiliatereport works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/affiliate/affiliatereport/affiliatereport.component.html
// module id = ../../../../../src/app/components/pages/affiliate/affiliatereport/affiliatereport.component.html
// module chunks = main